import { HHChip } from '@hinge-health/react-component-library';
import { Theme } from '@mui/material';
import { SystemStyleObject } from '@mui/system';

interface FilterChipProps {
  label: string;
  isPressed: boolean;
  onClick: () => void;
  testId: string;
}

/**
 * One pressable filter chip: ink-on-paper when pressed, a muted tint when
 * not. Shared by the status and health chip groups so they read the same.
 * Hover uses MUI's focus-visible class rather than `:focus-visible` because
 * jsdom applies pseudo-class rules in computed styles.
 */
export const FilterChip = ({
  label,
  isPressed,
  onClick,
  testId,
}: FilterChipProps): JSX.Element => (
  <HHChip
    hhVariant="variant-bypass"
    clickable
    label={label}
    aria-pressed={isPressed}
    data-testid={testId}
    onClick={onClick}
    sx={(theme: Theme): SystemStyleObject<Theme> => ({
      fontWeight: 500,
      ...(isPressed
        ? {
            backgroundColor: theme.palette.text.primary,
            color: theme.palette.background.paper,
            '&:hover, &.Mui-focusVisible': {
              backgroundColor: theme.palette.text.primary,
            },
          }
        : {
            backgroundColor: theme.palette.info.light,
            color: theme.palette.text.secondary,
            '&:hover, &.Mui-focusVisible': {
              backgroundColor: theme.palette.info.main,
            },
          }),
    })}
  />
);
